import React, { useMemo } from 'react';
import PageShell from '../../components/PageShell';
import { useP } from '../../i18n/useP';
import { usePersistentValue } from '../../hooks/usePersistentState';
import FinancingPlanPage from './FinancingPlanPage';
import DebtManualCard from './DebtManualCard';

/* FINANCE › DONNÉES ET RÉGLAGES › EMPRUNTS ET APPORTS (décision Olivier,
   2026-09-30). DEUX MODES depuis le 2026-10-03 : MANUEL, les comptes de fonds
   étrangers et leurs remboursements à venir, qui nourrissent le bilan et le
   plan de liquidité ; CALCULÉ, les contrats rejoués et rapprochés des comptes,
   « bientôt disponible », qui reste un contrôle. Le mode ne règle que l'ÉCRAN :
   c'est toujours le Manuel qui alimente les états. */
export default function FinancingSection({ activeTenant, addToast, year, canWrite = true }) {
  const p = useP();
  const tid = activeTenant?.id;
  const [unit, setUnit] = usePersistentValue(`prev_unit_${tid}`, 'kchf');
  const [mode, setMode] = usePersistentValue(`debt_mode_${tid}`, 'manual');
  const pageUnit = useMemo(() => ({ value: unit, onChange: setUnit }), [unit, setUnit]);
  const views = useMemo(() => [{
    id: 'mode', kind: 'segmented', label: p('Mode'), value: mode, onChange: setMode,
    options: [
      { id: 'manual', label: p('Manuel') },
      { id: 'calc', label: <>{p('Calculé')}<span className="lk-soon">{p('bientôt disponible')}</span></>,
        hint: p('Un contrôle : il ne nourrit pas encore le bilan ni le plan de liquidité') },
    ],
  }], [p, mode, setMode]);
  return (
    <PageShell kind="report" title={p('Emprunts et apports')} unit={pageUnit} views={views}>
      {mode === 'calc'
        ? <FinancingPlanPage activeTenant={activeTenant} year={year} unit={unit} addToast={addToast} />
        : <DebtManualCard activeTenant={activeTenant} year={year} unit={unit} canWrite={canWrite} />}
    </PageShell>
  );
}
